import * as React from 'react'
import { useAylaTimeout } from '~/components/shared/AylaTimeout'

export const useAiResponseStream = () => {
  const [aiResponse, setAiResponse] = React.useState('')
  const [researchId, setResearchId] = React.useState(null)
  const [aiStreamComplete, setAiStreamComplete] = React.useState(false)
  const [aiStreamEmpty, setAiStreamEmpty] = React.useState(false)
  const [aiStreamClosed, setAiStreamClosed] = React.useState(false)
  const { timedOut, resetTimeout } = useAylaTimeout({
    waiting: !!researchId && !aiStreamClosed && !aiStreamEmpty,
    activity: aiResponse,
  })
  const aiFailed = timedOut || aiStreamEmpty

  React.useEffect(() => {
    if (!researchId) return
    if (timedOut) return

    const eventURL = `/research_learning/ayla/create_ai_sse/${researchId}?format=json`
    const eventSource = new EventSource(eventURL)
    let received = false

    eventSource.addEventListener('message', (event) => {
      if (event.data != 'null') {
        received = true
        setAiResponse((r) => `${r}${event.data}`)
      }
    })

    eventSource.addEventListener('error', (event) => {
      if (event.eventPhase === EventSource.CLOSED) {
        eventSource.close()
        if (received) {
          setAiStreamClosed(true)
        } else {
          setAiStreamEmpty(true)
        }
      }
    })

    return () => {
      eventSource.close()
    }
  }, [researchId, timedOut])

  const resetAiResponse = React.useCallback(() => {
    setResearchId(null)
    setAiResponse('')
    setAiStreamComplete(false)
    setAiStreamEmpty(false)
    setAiStreamClosed(false)
    resetTimeout()
  }, [resetTimeout])

  return {
    aiResponse,
    setAiResponse,
    researchId,
    setResearchId,
    aiStreamComplete,
    setAiStreamComplete,
    aiFailed,
    resetAiResponse,
  }
}
